import React from 'react';
import PropTypes from 'prop-types';
import { isLastSectionGetLink } from 'StaticBuilder/Utils';
import NavSideBarListSection from './NavSideBarListSection';
import NavSideBarListSectionWithDropDown from './NavSideBarListSectionWithDropDown';

export default class NavSideBarListWithSections extends React.Component {
  constructor(props) {
    super(props);

    this.getCategoriesWithSections = this.getCategoriesWithSections.bind(this);
  }

  getCategoriesWithSections() {
    const categories = Object.keys(this.props.categories);
    const categoriesWithSections = categories.filter(potentialCategory => (
      Array.isArray(this.props.categories[potentialCategory])
    ));

    return categoriesWithSections;
  }

  render() {
    const isDropdown = !this.props.offsiteBuilder;
    const { documentType, releaseType } = this.props;
    const navSideBarList = [];
    const categoriesWithSections = this.getCategoriesWithSections();
    const isGetLink = isLastSectionGetLink(documentType, releaseType);

    const numOfCategories = categoriesWithSections.length;
    let offsetIdx = 0;

    for (let i = 0; i < numOfCategories; i += 1) {
      const category = categoriesWithSections[i];
      const sections = this.props.categories[category];
      const lastCategory = (i + 1) === numOfCategories;

      const listSectionProps = {
        category,
        documentType: this.props.documentType,
        isLastSectionGetLink: lastCategory && isGetLink,
        key: category,
        loadStaticBuilderSection: this.props.loadStaticBuilderSection,
        offsetIdx,
        offsiteBuilder: this.props.offsiteBuilder,
        onStep: this.props.onStep,
        sections,
        showRequestSignature: this.props.showRequestSignature && lastCategory,
      };

      let navSideBarListSection = (<NavSideBarListSection {...listSectionProps} />);

      if (isDropdown) {
        navSideBarListSection = (
          <NavSideBarListSectionWithDropDown {...listSectionProps} />
        );
      }

      offsetIdx += sections.length;
      navSideBarList.push(navSideBarListSection);
    }

    return (
      <React.Fragment>
        {navSideBarList}
      </React.Fragment>
    );
  }
}

NavSideBarListWithSections.defaultProps = {
  categories: {},
  offsiteBuilder: false,
  onStep: 0,
  releaseType: '',
  showRequestSignature: false,
};

NavSideBarListWithSections.propTypes = {
  categories: PropTypes.shape({}),
  documentType: PropTypes.string.isRequired,
  loadStaticBuilderSection: PropTypes.func.isRequired,
  offsiteBuilder: PropTypes.bool,
  onStep: PropTypes.number,
  releaseType: PropTypes.string,
  showRequestSignature: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/NavSideBarList/NavSideBarListWithSections.jsx